import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import withGuid from "../../hocs/with_guid.js";
import { withStyles } from '@material-ui/styles';
import { ButtonVariantOutlined } from "./constants.js";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Button from "./button.js"
import I18n from "../i18n.js.jsx";
import { compose } from 'redux';
import Color from "color";

const styles = theme => ({
  input: {
    display: 'none',
  },
  button: {
    padding: "7px 10px",
  },
  error: {
    backgroundColor: Color(theme.palette.redError).alpha(0.1).string(),
  },
});

/**
 * Callback for UploadButton
 * @callback UploadButton~onChange
 * @param {file} file Single file or array of files (depends on props.multiple of {@link UploadButton})
 */

/**
 * File picker button. Use for upload file
 * @name UploadButton
 * @param {object} props React component properties
 * @param {boolean} [props.multiple = false] Allow multiple files picking
 * @param {string} [props.text = "Upload"] Text on the button
 * @param {string} [props.accept = "image/*"] Available content types
 * @param {UploadButton~onChange} [props.onChange] On file picked callback
 * @param {boolean} [props.hasError = false] Indicates errors after file uploading
 * @example
 * return (
 *    <UploadButton multiple = { true }
 *                  onChange = { (file) => {
 *                    // Some actions
 *                  } } 
 *                  accept = { "application/pdf" }/>
 * )
*/

class UploadButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  onChange = (event) => {
    const { onChange, multiple } = this.props;
    let value;
    if(multiple) {
      value = [ ...event.target.files ];
    }
    else {
      value = event.target.files[0];
    }
    if(onChange && value) {
      onChange(value);
    }
    this.filePicker.value = "";
  }

  static getDerivedStateFromProps(props, state) {
    return {
      hasError: props.hasError
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.hasError !== nextState.hasError;
  }

  render() {
    let { accept, guid, classes, text, multiple } = this.props;
    const { hasError } = this.state;
    return <div>
      <input className = { classes.input }
             id = { guid }
             type = "file"
             multiple = { multiple ? multiple : undefined }
             accept = { accept }
             onChange = { this.onChange }
             ref = { (ref) => this.filePicker = ref } />
      <label htmlFor = { guid } >
        <Button className = { clsx({
          [classes.button]: true,
          [classes.error]: hasError
        }) }
                variant = { ButtonVariantOutlined }
                component = { "span" }
                startIcon = { <CloudUploadIcon /> } >
          { text }
        </Button>
      </label>
    </div>
  }
}

UploadButton.propTypes = {
  accept: PropTypes.string,
  text: PropTypes.string,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  hasError: PropTypes.bool
};

UploadButton.defaultProps = {
  accept: "image/*",
  text: I18n.t("action.upload"),
  multiple: false,
  hasError: false
}

export default compose(
  withGuid,
  withStyles(styles, { name: 'UploadButton' })
)(UploadButton);
